import { Pipe, PipeTransform } from '@angular/core';
import { ApplicationStatusCode } from '../models/application-general.model';

@Pipe({
  standalone: false,
  name: 'applicationStatus'
})
export class ApplicationStatusPipe implements PipeTransform {
  private types: any = {};

  constructor() {
    this.types[ApplicationStatusCode.new] = 'New';
    this.types[ApplicationStatusCode.inProgress] = 'In progress';
    this.types[ApplicationStatusCode.completed] = 'In progress';
    this.types[ApplicationStatusCode.pendingPaymentPlanApproval] = 'In progress';
    this.types[ApplicationStatusCode.approved] = 'Approved';
    this.types[ApplicationStatusCode.rejected] = 'Declined';
    this.types[ApplicationStatusCode.canceled] = 'In progress';
    this.types[ApplicationStatusCode.error] = 'Error';
    this.types[ApplicationStatusCode.pendingManagerApproval] = 'Pending manager approval';
    this.types[ApplicationStatusCode.archived] = 'Closed';
    this.types[ApplicationStatusCode.screening] = 'Screening';
    this.types[ApplicationStatusCode.pendingScreeningManualApproval] = 'Pending Screening Approval';
    this.types[ApplicationStatusCode.reopened] = 'Reopened';
  }

  transform(value?: ApplicationStatusCode): string {
    return this.types[value ? value : ''] ?? 'Unknown';
  }
}
